<template>
    <div :class="rootClass">
        <label v-if="label">{{ label }}</label>
        <div
            class="sip-segmented-control"
            role="group"
            :aria-label="ariaLabel || label || undefined"
        >
            <button
                type="button"
                class="sip-segmented-btn"
                :class="{ 'is-active': !isOn }"
                :disabled="disabled"
                @click="set(falseValue)"
            >
                <em class="icon ni ni-cross-sm"></em>
                <span>{{ noText }}</span>
            </button>
            <button
                type="button"
                class="sip-segmented-btn sip-segmented-btn--accent"
                :class="{ 'is-active': isOn }"
                :disabled="disabled"
                @click="set(trueValue)"
            >
                <em class="icon ni ni-check-sm"></em>
                <span>{{ yesText }}</span>
            </button>
        </div>
    </div>
</template>

<script>
/**
 * Shared Yes/No tape (segmented) control — replaces vue-switches / custom-switch.
 * Matches postal-record / reception drawer pattern (.sip-segmented-control).
 */
export default {
    name: 'SipYesNo',
    props: {
        value: {
            default: 0
        },
        trueValue: {
            default: 1
        },
        falseValue: {
            default: 0
        },
        label: {
            type: String,
            default: ''
        },
        ariaLabel: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        yesLabel: {
            type: String,
            default: ''
        },
        noLabel: {
            type: String,
            default: ''
        },
        fieldClass: {
            type: String,
            default: ''
        }
    },
    computed: {
        rootClass() {
            const classes = [];
            if (this.label || this.fieldClass) {
                classes.push('sip-segmented-field');
            } else {
                classes.push('sip-yes-no');
            }
            if (this.fieldClass) classes.push(this.fieldClass);
            return classes;
        },
        isOn() {
            const v = this.value;
            const t = this.trueValue;
            if (v === t) return true;
            if (t === 1 || t === true || t === '1') {
                return v === true || v === 1 || v === '1';
            }
            return !!v && v !== this.falseValue;
        },
        yesText() {
            return this.yesLabel || (typeof trans === 'function' ? (trans('list.yes') || 'Yes') : 'Yes');
        },
        noText() {
            return this.noLabel || (typeof trans === 'function' ? (trans('list.no') || 'No') : 'No');
        }
    },
    methods: {
        set(val) {
            if (this.disabled) return;
            if (this.value === val) return;
            this.$emit('input', val);
            this.$emit('change', val);
        }
    }
}
</script>
